import React from 'react';
import RegistrationsManager from '@/features/cms/components/RegistrationsManager';

const CmsRegistrationsPage: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <RegistrationsManager />
  </div>
);

export default CmsRegistrationsPage;
